var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleEmailFill = function SvgCircleEmailFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 12q101 0 172.5 71.5T500 256q0 66-32.5 122.5t-89 89T256 500q-101 0-172.5-71.5T12 256q0-66 32.5-122.5t89-89T256 12M152 185q-11 0-4 9 2 3 5 4 77 42 92 50 5 2 11.5 2t10.5-2q1-1 10-6t22-11.5 26-13.5 22.5-12.5T359 198q10-5 7-11-2-2-6-2zm214 130v-90q0-5-5-2-2 1-25 13t-45 23.5-24 12.5q-5 3-11 3t-11-3q-19-10-94-49-5-3-5 2v90q0 4 4 8t8 4h196q4 0 8-4t4-8"
  })));
};
export default SvgCircleEmailFill;